import { graphql, Link, useStaticQuery } from 'gatsby';
import React from 'react';
import SEO from '../../components/SEO';
import GetSEOData from '../../data/SEO';
import TownGrid from '../../components/location/TownGrid';
import HeroSection from '../../components/HeroSection';
const TownsPage = () => {
  const { title, description } = GetSEOData('towns');
  return (
    <>
      <SEO title={title} description={description} />
      <HeroSection
        heading="Our Towns"
        className="NewsheroSection webite_template"
        backgroundImage="hero-images/newsBackground.jpg"
      />
      <section className="container pt-2">
        <div className="row">
          <div className="col-12 text-left">
            <p style={{ fontSize: '2.4rem' }}>
              Our engineers are bringing ultrafast, reliable full fibre
              broadband to homes across the UK. We're constantly adding new
              towns to our plans - see if your town is listed below or click the
              button to check availability. Remember, if you can't get Lit
              today, register your interest to be the first to find out when
              we're coming to you.
            </p>
          </div>
          <div className="col-12 text-center pt-2">
            <Link to="/get-lit">
              <button className="button">Check if you can get Lit</button>
            </Link>
          </div>
        </div>
      </section>
      <TownGrid />
    </>
  );
};

export default TownsPage;

const query = () =>
  useStaticQuery(graphql`
    {
      # Images
      desktopHero: file(
        relativePath: { eq: "hero-images/registerInterestHeader.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);
